import React from 'react';

import { Box, Chip, Stack, Tooltip, alpha } from '@mui/material';

import { departureActionDetail, departureActionGroups } from './departureActions';
import { flagLabels } from './logic';
import { actionColour, actionText } from './palette';
import { CommandDeparture, CommandFlag, CostBasis } from './types';

export default function DepartureActionPills({
  rows,
  basis,
  selected,
}: {
  rows: CommandDeparture[];
  basis: CostBasis;
  selected?: CommandFlag | 'all' | null;
}) {
  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5}>
      {departureActionGroups(rows, basis).map(({ flag, rows: departures }) => (
        <Tooltip
          key={flag}
          title={
            <Box sx={{ whiteSpace: 'pre-line' }}>
              {departures.map((d) => departureActionDetail(d, basis)).join('\n')}
            </Box>
          }
        >
          <Chip
            size="small"
            data-departure-action={flag}
            data-count={departures.length}
            aria-label={`Departures: ${flagLabels[flag]} ${departures.length}`}
            label={`${flagLabels[flag]} ${departures.length}`}
            sx={{
              fontSize: 11,
              fontWeight: 700,
              color: actionText(flag),
              bgcolor: alpha(actionColour(flag), 0.14),
              border: '2px solid',
              borderColor: selected === flag ? actionColour(flag) : 'transparent',
              maxWidth: '100%',
              height: 'auto',
              minHeight: 26,
              '& .MuiChip-label': { whiteSpace: 'normal', px: 0.75, py: 0.25 },
            }}
          />
        </Tooltip>
      ))}
    </Stack>
  );
}
